import { useState } from 'react';

const initialState = { name: '', email: '', message: '' };

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');
    const formData = new FormData(e.target);
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => { setStatus('sent'); setState({ ...initialState }); })
      .catch(() => setStatus('error'));
  };

  const year = new Date().getFullYear();

  const infoItems = [
    {
      icon: 'fa fa-map-marker',
      label: 'Our Location',
      value: props.data?.address,
      href: props.data?.googleBusiness,
      external: true,
    },
    {
      icon: 'fa fa-phone',
      label: 'Call Us Anytime',
      value: props.data?.phone,
      href: `tel:${props.data?.phone}`,
    },
    {
      icon: 'fa fa-envelope-o',
      label: 'Send an Email',
      value: props.data?.email,
      href: `mailto:${props.data?.email}`,
    },
    {
      icon: 'fa fa-clock-o',
      label: 'Working Hours',
      value: '24 / 7 — Always Available',
      href: null,
    },
  ];

  const socials = [
    { icon: 'fa fa-facebook', href: props.data?.facebook, label: 'Facebook' },
    { icon: 'fa fa-google', href: props.data?.googleBusiness, label: 'Google Business' },
    { icon: 'fa fa-whatsapp', href: 'https://wa.me/2348103218560', label: 'WhatsApp' },
  ].filter(s => s.href);

  return (
    <div>
      <section id='contact' style={{ padding: '100px 0', background: '#0a0a14' }}>
        <div className='container'>

          {/* ── Section Header ── */}
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <p style={{
              color: '#5ca9fb', fontWeight: '700',
              fontSize: '12px', letterSpacing: '3px',
              textTransform: 'uppercase', margin: '0 0 16px',
            }}>
              — Get In Touch
            </p>
            <h2 style={{
              fontFamily: 'Raleway, sans-serif',
              fontSize: 'clamp(32px, 4vw, 52px)',
              fontWeight: '800', color: '#fff',
              lineHeight: '1.1', margin: '0 0 16px',
            }}>
              Let's Talk <span style={{ color: '#5ca9fb' }}>HVAC</span>
            </h2>
            <p style={{
              color: 'rgba(255,255,255,0.45)',
              fontSize: '16px', maxWidth: '480px',
              margin: '0 auto', lineHeight: '1.75',
            }}>
              Have a project in mind? Send us your requirements and our team will respond within 24 hours.
            </p>
          </div>

          {/* ── Two-column layout ── */}
          <div className='contact-layout'>

            {/* ── LEFT: Form ── */}
            <div>
              <div style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '24px',
                padding: '44px 40px',
              }}>
                <h3 style={{
                  fontFamily: 'Raleway, sans-serif',
                  fontSize: '20px', fontWeight: '800',
                  color: '#fff', margin: '0 0 6px',
                }}>
                  Request a Free Quote
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '14px', margin: '0 0 32px' }}>
                  Fill in your details and we'll get back to you shortly.
                </p>

                <form name='contact' data-netlify='true' data-netlify-honeypot='bot-field' onSubmit={handleSubmit}>
                  <input type='hidden' name='form-name' value='contact' />
                  <input type='hidden' name='bot-field' />
                  {/* Name + Email row */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }} className='form-row-2'>
                    <div>
                      <label style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontWeight: '700', letterSpacing: '0.5px', textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                        Your Name
                      </label>
                      <input
                        type='text'
                        name='name'
                        value={name}
                        placeholder='e.g. Chukwuemeka John'
                        required
                        onChange={handleChange}
                        className='contact-input'
                      />
                    </div>
                    <div>
                      <label style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontWeight: '700', letterSpacing: '0.5px', textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                        Email Address
                      </label>
                      <input
                        type='email'
                        name='email'
                        value={email}
                        placeholder='you@example.com'
                        required
                        onChange={handleChange}
                        className='contact-input'
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontWeight: '700', letterSpacing: '0.5px', textTransform: 'uppercase', display: 'block', marginBottom: '8px' }}>
                      Your Message
                    </label>
                    <textarea
                      name='message'
                      value={message}
                      rows='5'
                      placeholder='Describe your HVAC requirements — installation, maintenance, energy audit, emergency support...'
                      required
                      onChange={handleChange}
                      className='contact-input'
                      style={{ resize: 'vertical', minHeight: '130px' }}
                    />
                  </div>

                  {/* Submit button */}
                  <button
                    type='submit'
                    disabled={status === 'sending' || status === 'sent'}
                    style={{
                      width: '100%',
                      background: status === 'sent'
                        ? 'linear-gradient(to right, #43e97b, #38f9d7)'
                        : 'linear-gradient(to right, #5ca9fb, #6372ff)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '12px',
                      padding: '15px 28px',
                      fontSize: '14px',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      cursor: status === 'sending' || status === 'sent' ? 'default' : 'pointer',
                      boxShadow: '0 8px 24px rgba(92,169,251,0.35)',
                      transition: 'opacity 0.2s',
                      opacity: status === 'sending' ? 0.7 : 1,
                      fontFamily: 'Lato, sans-serif',
                    }}
                  >
                    {status === 'sending' && '⏳ Sending...'}
                    {status === 'sent' && '✓ Message Sent!'}
                    {status === 'error' && 'Retry — Send Message'}
                    {status === 'idle' && 'Send Message →'}
                  </button>

                  {/* Error notice */}
                  {status === 'error' && (
                    <p style={{ color: '#ff6b6b', fontSize: '13px', marginTop: '12px', textAlign: 'center' }}>
                      Something went wrong. Please call us directly on{' '}
                      <a href='tel:08103218560' style={{ color: '#5ca9fb' }}>08103218560</a>.
                    </p>
                  )}
                </form>
              </div>
            </div>

            {/* ── RIGHT: Info ── */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

              {/* Info cards */}
              {infoItems.map((item, i) => {
                const Inner = (
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                    <div className='contact-icon-box' style={{
                      width: '46px', height: '46px',
                      borderRadius: '12px',
                      background: 'rgba(92,169,251,0.1)',
                      border: '1px solid rgba(92,169,251,0.2)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      <i className={item.icon} style={{
                        fontSize: '16px', color: '#5ca9fb',
                        display: 'inline', width: 'auto', height: 'auto',
                        padding: 0, background: 'none', boxShadow: 'none',
                        borderRadius: 0, margin: 0, lineHeight: 1, transition: 'none',
                      }}></i>
                    </div>
                    <div>
                      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '4px' }}>
                        {item.label}
                      </div>
                      <div style={{ color: '#fff', fontSize: '14px', fontWeight: '600', lineHeight: '1.4' }}>
                        {item.value || '—'}
                      </div>
                    </div>
                  </div>
                );

                return item.href ? (
                  <a
                    key={i}
                    href={item.href}
                    target={item.external ? '_blank' : undefined}
                    rel={item.external ? 'noopener noreferrer' : undefined}
                    style={{
                      display: 'block',
                      background: 'rgba(255,255,255,0.04)',
                      border: '1px solid rgba(255,255,255,0.08)',
                      borderRadius: '14px',
                      padding: '18px 20px',
                      textDecoration: 'none',
                      transition: 'border-color 0.25s, background 0.25s',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.borderColor = 'rgba(92,169,251,0.35)';
                      e.currentTarget.style.background = 'rgba(92,169,251,0.05)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
                      e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                    }}
                  >
                    {Inner}
                  </a>
                ) : (
                  <div
                    key={i}
                    style={{
                      background: 'rgba(255,255,255,0.04)',
                      border: '1px solid rgba(255,255,255,0.08)',
                      borderRadius: '14px',
                      padding: '18px 20px',
                    }}
                  >
                    {Inner}
                  </div>
                );
              })}

              {/* Google Rating compact card */}
              {props.data?.rating && (
                <div style={{
                  background: 'linear-gradient(135deg, rgba(92,169,251,0.12), rgba(99,114,255,0.08))',
                  border: '1px solid rgba(92,169,251,0.25)',
                  borderRadius: '14px',
                  padding: '20px',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                      <svg width='32' height='32' viewBox='0 0 24 24' style={{ flexShrink: 0 }}>
                        <path fill='#4285F4' d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z'/>
                        <path fill='#34A853' d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z'/>
                        <path fill='#FBBC05' d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z'/>
                        <path fill='#EA4335' d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z'/>
                      </svg>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                          <span style={{ fontFamily: 'Raleway, sans-serif', fontSize: '28px', fontWeight: '900', color: '#fff', lineHeight: 1 }}>
                            {props.data.rating}
                          </span>
                          <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '13px' }}>/ 5</span>
                        </div>
                        <div style={{ display: 'flex', gap: '2px', marginTop: '4px' }}>
                          {[1,2,3,4].map(n => (
                            <svg key={n} width='14' height='14' viewBox='0 0 24 24' fill='#FFB800'>
                              <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/>
                            </svg>
                          ))}
                          <svg width='14' height='14' viewBox='0 0 24 24'>
                            <defs>
                              <linearGradient id='hs2' x1='0' x2='1' y1='0' y2='0'>
                      <stop offset='50%' stopColor='#FFB800'/>
                      <stop offset='50%' stopColor='rgba(255,255,255,0.2)'/>
                              </linearGradient>
                            </defs>
                            <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' fill='url(#hs2)'/>
                          </svg>
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '3px' }}>
                          {props.data.reviewCount} verified reviews
                        </div>
                      </div>
                    </div>
                    <a
                      href={props.data.googleBusiness}
                      target='_blank'
                      rel='noopener noreferrer'
                      style={{
                        display: 'inline-block',
                        background: 'rgba(255,255,255,0.1)',
                        border: '1px solid rgba(255,255,255,0.15)',
                        borderRadius: '20px',
                        padding: '7px 16px',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: '700',
                        textDecoration: 'none',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      View on Google
                    </a>
                  </div>
                </div>
              )}

              {/* Social links */}
              <div style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '14px',
                padding: '20px',
              }}>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px', margin: '0 0 14px' }}>
                  Follow Us
                </p>
                <div style={{ display: 'flex', gap: '10px' }}>
                  {socials.map((s, i) => (
                    <a
                      key={i}
                      href={s.href || '#'}
                      target='_blank'
                      rel='noopener noreferrer'
                      title={s.label}
                      className='social-icon-btn'
                      style={{
                        width: '42px', height: '42px',
                        borderRadius: '10px',
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(255,255,255,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        textDecoration: 'none',
                        color: 'rgba(255,255,255,0.6)',
                        transition: 'background 0.25s, border-color 0.25s, color 0.25s',
                        fontSize: '16px',
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.background = 'rgba(92,169,251,0.15)';
                        e.currentTarget.style.borderColor = 'rgba(92,169,251,0.4)';
                        e.currentTarget.style.color = '#5ca9fb';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                        e.currentTarget.style.color = 'rgba(255,255,255,0.6)';
                      }}
                    >
                      <i className={s.icon} style={{
                        display: 'inline', width: 'auto', height: 'auto',
                        padding: 0, background: 'none', boxShadow: 'none',
                        borderRadius: 0, margin: 0, lineHeight: 1, transition: 'none',
                        fontSize: '16px', color: 'inherit',
                      }}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer id='footer' style={{
        background: '#060610',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '32px 0',
      }}>
        <div className='container'>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
          }}>
            <div>
              <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '13px', margin: 0 }}>
                &copy; {year} <strong style={{ color: 'rgba(255,255,255,0.6)' }}>ACTECH Air Conditioning Services</strong>. All rights reserved.
              </p>
              <p style={{ color: 'rgba(255,255,255,0.2)', fontSize: '12px', margin: '4px 0 0' }}>
                103, Olaitan Odularu Street, Surulere, Lagos · Nigeria
              </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#43e97b', boxShadow: '0 0 6px #43e97b' }} />
              <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '12px', fontWeight: '600' }}>
                Open 24/7 · Always Available
              </span>
            </div>
          </div>
        </div>
      </footer>

      <style>{`
        .contact-layout {
          display: grid;
          grid-template-columns: 1.15fr 1fr;
          gap: 40px;
          align-items: start;
        }

        .contact-input {
          width: 100%;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.12);
          border-radius: 10px;
          padding: 13px 16px;
          color: #fff;
          font-size: 14px;
          font-family: Lato, sans-serif;
          outline: none;
          transition: border-color 0.25s, background 0.25s;
          box-sizing: border-box;
          display: block;
        }

        .contact-input::placeholder {
          color: rgba(255,255,255,0.28);
        }

        .contact-input:focus {
          border-color: #5ca9fb;
          background: rgba(92,169,251,0.06);
        }

        /* Reset all FA blob styles inside contact */
        #contact .contact-icon-box i.fa,
        #contact .social-icon-btn i.fa {
          font-size: 16px !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
          line-height: inherit !important;
        }

        @media (max-width: 860px) {
          .contact-layout {
            grid-template-columns: 1fr !important;
          }
          .form-row-2 {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};
